import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { palette } from "../../../theme/palette";
import { typography } from "../../../theme/typography";
import styled from "@emotion/styled";
import Badge from "@mui/material/Badge";
import classNames from "classnames";
const StyledBadge = styled(Badge)(({ size = "medium", backgroundColor = "primary" }) => {
    return {
        "& .MuiBadge-badge": {
            color: palette.white,
            // paddingTop: "2px", PC에 따라 숫자가 위로 경우가 있음. font 이슈로 보여 paddingTop을 줬었지만 중앙에 잘 위치하는 PC도 있어서 제거함.
            ...(size === "large" && {
                height: "20px",
                minWidth: "20px",
                minHeight: "20px",
                padding: "0 4px",
                ...typography["Content.Caption02"],
            }),
            ...(size === "medium" && {
                height: "14px",
                minWidth: "14px",
                minHeight: "14px",
                padding: "0 4px",
                ...typography["Content.Caption03"],
            }),
            ...(size === "small" && {
                width: "6px",
                height: "6px",
                minWidth: "6px",
                minHeight: "6px",
                padding: "0",
            }),
            ...(backgroundColor === "primary" && {
                backgroundColor: palette["maven-blue-bright"],
            }),
            ...(backgroundColor === "grey" && {
                backgroundColor: palette.grey080,
            }),
            ...(backgroundColor === "red" && {
                backgroundColor: palette.red050,
            }),
            ...(backgroundColor === "orange" && {
                backgroundColor: palette.orange050,
            }),
            ...(backgroundColor === "green" && {
                backgroundColor: palette.green050,
            }),
            ...(backgroundColor === "purple" && {
                backgroundColor: palette.purple060,
            }),
            ...(backgroundColor === "navy" && {
                backgroundColor: palette.darkNavy040,
            }),
        },
    };
});
/** badge를 달고 싶은 컴포넌트를 GrBadge가 감싸는 형태로 사용 */
export function GrBadge(props) {
    const { count, maxCount, variant, invisible, children, showZero, className, ...others } = props;
    return (_jsx(StyledBadge, { className: classNames("GrBadge", className), badgeContent: props.size === "small" ? "" : count, max: maxCount, variant: variant, invisible: invisible, showZero: showZero, ...others, children: children }));
}
//# sourceMappingURL=GrBadge.js.map